import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element-cust.scss';
import './assets/font/iconfont.css' //自定义icon
Vue.use(ElementUI);
Vue.config.productionTip = false

import request from './request/request'
import AES from '@/request/AES'
Vue.prototype.$request = request;
Vue.prototype.$aes = AES;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
